import {Button} from "@mui/material";
import React from "react";
import {useTranslation} from "react-i18next";
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router";
import {deleteLeague} from "modules/actions/leagues";
import {showPromptModal} from "modules/actions/prompt_modal";
import styled from "@emotion/styled";
import {ILeague} from "modules/types/leagues";

const DeleteGroupWrapper = styled.div`
	display: flex;
	flex-flow: column;
	gap: 16px;
`;

const DeleteText = styled.div`
	display: flex;
	flex-flow: column;
	gap: 8px;

	p {
		font-weight: 400;
		font-size: 14px;
		line-height: 130%;
		&:first-of-type {
			font-weight: 700;
			font-size: 16px;
			line-height: 130%;
		}
	}
`;

const useDeleteLeague = (currentLeague: ILeague) => {
	const i18n = useTranslation();
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const deleteGroup = () => {
		if (currentLeague) {
			dispatch(
				deleteLeague({
					leagueId: currentLeague.id,
					onSuccess: () => navigate("/groups"),
				})
			);
		}
	};

	const deleteGroupConfirm = () => {
		if (currentLeague) {
			dispatch(
				showPromptModal({
					title: i18n.t("update_league.delete.modal_title", "Are you sure?"),
					description: i18n.t(
						"update_league.delete.modal_description",
						`You are deleting the group ${currentLeague.name}. This action cannot be reversed.`,
						{
							name: currentLeague.name,
						}
					),
					denyButton: {
						text: i18n.t("update_league.delete.cancel", "No, Cancel"),
					},
					confirmButton: {
						text: i18n.t("update_league.delete.confirm", "Yes, Delete"),
						onClick: deleteGroup,
					},
				})
			);
		}
	};

	return {
		deleteGroupConfirm,
		i18n,
	};
};

interface IProps {
	currentLeague: ILeague;
}

const DeleteLeague: React.FC<IProps> = ({currentLeague}) => {
	const {deleteGroupConfirm, i18n} = useDeleteLeague(currentLeague);
	return (
		<DeleteGroupWrapper>
			<DeleteText>
				<p>{i18n.t("update_league.delete.title", "Delete group")}</p>
				<p>
					{i18n.t(
						"update_league.delete.description",
						"Deleting a group, can not be reversed."
					)}
				</p>
			</DeleteText>

			<Button variant={"contained"} color={"error"} onClick={deleteGroupConfirm}>
				{i18n.t("update_league.form.delete", "Delete Group")}
			</Button>
		</DeleteGroupWrapper>
	);
};

export default DeleteLeague;
